<template>
  <div class="EventForm">
    <DataLoader
      :key="props.eventId"
      :url="_eventFetchURL"
      :event-id="props.eventId"
    >
      <template #loader>
        <div id="spinner"><PulseLoader /></div>
      </template>
      <template #data="{ data }">
        <EventForm :event="data" @close-form="$emit('closeForm')" />
        <hr />
      </template>
      <template #error="{ error }"> {{ error }}</template>
    </DataLoader>
  </div>
</template>

<script setup>
import DataLoader from "./DataLoader.vue";
import EventForm from "./EditForm.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

const props = defineProps({
  eventId: {
    type: [Number, String],
    default: null,
  },
});
const _eventFetchURL = "/api/bookings/" + props.eventId;
defineEmits(["closeForm"]);
</script>

<style>
#spinner {
  text-align: center;
}
</style>
